import { render } from "./singleProduct.vue?vue&type=template&id=7667ed86&scoped=true"
import script from "./singleProduct.vue?vue&type=script&lang=js"
export * from "./singleProduct.vue?vue&type=script&lang=js"

import "./singleProduct.vue?vue&type=style&index=0&id=7667ed86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7667ed86"]])

export default __exports__